// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1QivN","head":"Table_head__2senv","col":"Table_col__PyKHl"};